
import utils from "../utils/index";
import * as CONSTANTS from "../constants/index";
import XInput from 'vux/src/components/x-input/index.vue'

import Group from 'vux/src/components/group/index.vue'

import { mapMutations, mapState } from "vuex";

export default {
name: "BusinessList",
data() {
return {
changeValue: "",
timer: "",
originResult: [],
results: [],
value: "",
title: "行业",
type: "",
carBeans: utils.deepClone(CONSTANTS.CAR_BEANS),
};
},
components: {
XInput,
Group,
},
created() {
this.carBeans = this.quoteInfo;
this.type = this.$route.params.type || this.type;
this.title = this.$route.params.title || this.title;
},
mounted() {
this.queryOccupation();
},
computed: {
...mapState({
quoteInfo: (state) => state.quote.quoteInfo,
businessList: (state) => state.businessList,
}),
},
methods: {
...mapMutations({
setBusinessList: "setBusinessList",
}),
queryOccupation() {

let _this = this;
if (Array.isArray(_this.businessList) && _this.businessList.length > 0) {
_this.originResult = utils.deepClone(_this.businessList);
_this.results = utils.deepClone(_this.businessList);
} else {

let _timestamp = new Date().getTime();
$http
.queryBusinessMainConfig({
data: {
businessCode: "",
businessName: "",
timestamp: _timestamp,
},
})
.then((res) => {
let _result = [];
if (res.resultCode === "0") {
_result = res.result;
}
_this.setBusinessList(_result);
_this.originResult = utils.deepClone(_result);
_this.results = utils.deepClone(_result);
});
}
},
saveBusiness(type, item) {
if (type) {
this.carBeans[type].businessCode = item.businessCode;
this.carBeans[type].businessName = item.businessName;
if (/applicant|insured/g.test(type)) {
this.carBeans[type].sameFlag = false; 
}
}
return Promise.resolve();
},
goBack(type) {
if (type === "owner") {
this.$router.back();
} else if (/applicant|insured/g.test(type)) {
let _type = type === "applicant" ? 2 : 1;
const flag = this.$route.params.flag
let path = '/owner_same'
let name = 'OwnerSame'
if (flag === 'hc') {
path = '/owner_same_hc'
name = 'OwnerSameHc'
} else if (flag === 'sd') {
path = '/owner_same_sd'
name = 'OwnerSameSd'
}
this.$router.push({
path,
name,
params: {
type: _type,
},
});
}
},
filterResult(val) {
let rs = [];
rs = this.originResult.filter((x) => {
return x.businessName.includes(val);
});
return rs;
},
onResultClick(item) {
this.saveBusiness(this.type, item).then(() => {
this.goBack(this.type);
});
},
onChange(value) {
this.changeValue = value;
this.debounce(this.setResult, 200)();
},
setResult(value = this.changeValue) {
this.results = value ? this.filterResult(value) : this.originResult;
},
debounce(fn, wait) {
let _this = this;
return function () {
if (_this.timer) {
clearTimeout(_this.timer);
}
_this.timer = setTimeout(fn, wait);
};
},
},
destroyed() {
clearTimeout(this.timer);
},
};
